module.exports = __webpack_public_path__ + "media/assets_v3/images/store-message-warn-aea08c2d3965431f6f1f3d8d26c82897.jpg";